<div class="container-fluid h-100">
  <div class="row h-100 ">
    <div class="col-auto bg-white h-100 d-none d-lg-block">
      <Sidebar ref="sidebar"></Sidebar>
    </div>
    <div class="col bg-white h-100 m-0">
      <Navbar @toggle-sidebar="toggleSidebar"></Navbar>
      <div class="bg-gray px-4 py-1 h-100 scroll-container">
        <div class="card bg-white mt-2 rounded-5 border-0">
          <div class="card-header border-0 bg-transparent rounded-5">
            <h5 class="fw-500">Portals created</h5>
            <button class="btn btn-secondary text-white text-xxs rounded-3 btn-sm fw-normal" @click="openCreateModal">
              <i class='bx bx-plus'></i> Create Portal
            </button>
          </div>
          <div class="card-body table-responsive">

            <table class="table text-xxs table-striped mt-3 bg-white">
              <thead class="bg-dark text-white">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Workstreams Portal</th>
                  <th scope="col">Portal Type</th>
                  <th scope="col">Master Portal</th>
                  <th scope="col">Is Private?</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(portal, index) in portals" :key="portal.id">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ portal.name }}</td>
                  <td>{{ portal.portal_type?.name }}</td>
                  <td>
                    {{ portal.master_portal.name === portal.name ? 'None' : portal.master_portal.name }}
                  </td>
                  <td id="portal_id">{{ portal.is_public }}</td>
             
                  <td>

                    <router-link :to="'create_segment/' + portal.id">
                      <button class="btn btn-secondary btn-sm text-xxs rounded-3 mx-1 btn-sm shadow">
                        View</button>
                    </router-link>
                    <button class="btn btn-success btn-sm text-xxs rounded-3 mx-1 btn-sm shadow"
                      @click="openEditModal(portal)">Edit</button>
                    <button @click="deletePortal(portal.id)"
                      class="btn btn-danger text-xxs btn-sm rounded-3 mx-1 btn-sm shadow">
                      Delete</button>

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="create_portal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title text-xs fw-500" id="exampleModalLabel">
          {{ isEditMode ? 'Edit Portal' : 'Create a Portal' }}
        </p>
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <form @submit.prevent="createPortal">
        <div class="modal-body">

          <!-- Portal Name -->
          <div class="mb-3">
            <label for="portal_name" class="form-label text-xs fw-500">Portal Name <span
                class="text-danger">*</span></label>
            <input type="text" class="form-control rounded-5 text-xs" id="portal_name" placeholder="Enter portal name"
              v-model="portal_name">
            <p v-if="errors.portal_name" class="text-danger text-xs">{{ errors.portal_name }}</p>
          </div>

          <!-- Portal Type -->
          <div class="mb-3">
            <label class="form-label text-xs fw-500">Portal Type</label>
            <div class="d-flex gap-3">
              <div v-for="type in portal_types" :key="type.id" class="form-check">
                <input type="radio" class="form-check-input" :id="'portal_type_' + type.id" :value="type"
                  v-model="selectedPortalType">
                <label class="form-check-label text-xs" :for="'portal_type_' + type.id">{{ type.name }}</label>
              </div>
            </div>
            <p v-if="errors.portal_type" class="text-danger text-xs">{{ errors.portal_type }}</p>
          </div>

          <!-- Incident Contact Email -->
          <div v-if="selectedPortalType && selectedPortalType.name === 'incident'">
            <div class="mb-3">
              <label for="contact_email" class="form-label text-xs fw-500">Authority Email</label>
              <input type="email" id="contact_email" class="form-control rounded-5 text-xs" v-model="contactEmail">
              <p v-if="errors.contact_email" class="text-danger text-xs">{{ errors.contact_email }}</p>
            </div>
          </div>

          <!-- Engagement Specific Fields -->
          <div v-if="selectedPortalType && selectedPortalType.name === 'engagement'">

            <!-- Is Master Portal -->
            <div class="mb-3">
              <label class="form-label text-xs fw-500">Is Master Portal?</label>
              <div class="d-flex gap-3">
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="is_master_yes" :value="true" v-model="isMaster">
                  <label class="form-check-label text-xs" for="is_master_yes">Yes</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="is_master_no" :value="false" v-model="isMaster">
                  <label class="form-check-label text-xs" for="is_master_no">No</label>
                </div>
              </div>
            </div>



            <!-- Sub-Portals (if Master) -->
            <div class="mb-3" v-if="isMaster">
              <a href="#" class="text-primary text-xs fw-500" data-bs-toggle="modal"
                data-bs-target="#select_portals_modal">+ Add Sub-Portals</a>
              <div class="text-xs">Selected sub-portals ({{ selectedPortals.length || 0 }})</div>
            </div>

            <!-- Master Portal (if Not Master) -->
            <div class="mb-3" v-if="!isMaster">
              <label class="form-label text-xs fw-500">Select Master Portal</label>
              <select class="form-control rounded-5 text-xs" v-model="selectedMasterPortal">
                <option value="" disabled selected>Select master portal</option>
                <option v-for="portal in portals" :key="portal.id" :value="portal.id">{{ portal.name }}</option>
              </select>
              <p v-if="errors.master_portal" class="text-danger text-xs">{{ errors.master_portal }}</p>
            </div>

            <!-- Public/Private -->
            <!-- Public/Private Radio Buttons -->
            <div class="d-flex gap-3 mt-2">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="flexRadioDefault" id="public" value="public"
                  v-model="selectedVisibility">
                <label class="form-check-label text-xs fw-500" for="public">
                  Public <br>
                  <span class="text-xxs text-secondary">Is the portal public?</span>
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="flexRadioDefault" id="private" value="private"
                  v-model="selectedVisibility">
                <label class="form-check-label text-xs fw-500" for="private">
                  Private <br>
                  <span class="text-xxs text-secondary">Is the portal private?</span>
                </label>
              </div>
            </div>


          </div>

          <!-- Member Selection (Private Only) -->
          <div v-if="selectedVisibility === 'private'" class="mt-3">
            <a href="#" class="text-primary text-xs fw-500" data-bs-toggle="modal"
              data-bs-target="#portal_member_modal">+ Add Portal members</a>
            <p v-if="errors.user_ids" class="text-danger text-xs">{{ errors.user_ids }}</p>
            <div class="text-xs">Tagged Members ({{ selectedUserIds.length || 0 }})</div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xs rounded-5">{{ isEditMode ? 'Update' : 'Post' }}</button>
        </div>
      </form>
    </div>
  </div>
</div>




<div class="modal fade" id="portal_member_modal" tabindex="-1" aria-labelledby="portalMemberLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title text-xs fw-500" id="portalMemberLabel">Add Portal Members</p>
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <form @submit.prevent="addPortalMembers">
        <div class="modal-body table-responsive">
          <div class="mb-3">
            <input type="text" v-model="searchQuery" class="form-control text-xs"
              placeholder="Search members by name..." />
          </div>
          <table class="table table-striped text-xs">
            <thead class="bg-dark text-white">
              <tr>
                <th scope="col">#</th>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Email</th>
                <th scope="col">Action<span class="ms-2"><input class="form-check-input" type="checkbox"
                      id="select_all_checkbox" :checked="areAllSelected" @change="toggleSelectAll" /></span></th>
              </tr>
            </thead>
            <tbody class="text-black">
              <tr v-for="(user, index) in filteredUsers" :key="user.id">
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ user.first_name }}</td>
                <td>{{ user.last_name }}</td>
                <td>{{ user.email }}</td>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" :id="'portal_member_check_' + user.id"
                      :value="user.id" v-model="selectedUserIds" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xs rounded-5">Add Members</button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="select_portals_modal" tabindex="-1" aria-labelledby="selectPortalsLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title text-xs fw-500" id="selectPortalsLabel">Select Sub-Portals</p>
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <form @submit.prevent="confirmSelectedPortals">
        <div class="modal-body">
          <!-- Search Input -->
          <div class="mb-3">
            <input type="text" v-model="searchQuery" class="form-control text-xs"
              placeholder="Search portals by name..." />
          </div>

          <!-- Portals Table -->
          <table class="table table-striped text-xs">
            <thead class="bg-dark text-white">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Portal Name</th>
                <th scope="col">
                  Action
                  <span class="ms-2">
                    <input class="form-check-input" type="checkbox" id="select_all_checkbox"
                      :checked="areAllSubPortalsSelected" @change="toggleSelectAllSubPortals" />
                  </span>
                </th>
              </tr>
            </thead>
            <tbody class="text-black">
              <tr v-for="(portal, index) in filteredPortals" :key="portal.id">
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ portal.name }}</td>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" :id="'portal_check_' + portal.id" :value="portal.id"
                      v-model="selectedPortals" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xs rounded-5">Add Portals</button>
        </div>
      </form>
    </div>
  </div>
</div>